// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./icon--palette.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* overridden by src/lib/themes/guiHelpers.js */

/* make sure to keep these in sync with other constants,
e.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */

/* layout contants from \`layout-constants.js\` */

.custom-procedures_modal-content_gpGU2 {
    width: 700px;
    margin: 50px auto; /* This modal is taller than most, reduce top margin */
}

.custom-procedures_body_Kv_MY {
    background: var(--ui-modal-background);
    padding: 1.5rem 2.25rem;
}

.custom-procedures_body_Kv_MY input[type="checkbox"],
.custom-procedures_body_Kv_MY input[type="radio"] {
    margin: 3px;
}

/* Blocks workspace for custom procedure declaration editor */

.custom-procedures_workspace_GChHs {
    min-height: 200px;
    position: relative;
}

.custom-procedures_workspace_GChHs .injectionDiv{
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
}

.custom-procedures_workspace_GChHs .blocklySvg {
    background-color: var(--ui-primary);
}

/* Row of "card" buttons for modifying custom procedures */

.custom-procedures_options-row_aOcgo {
    display: flex;
    justify-content: space-between;
}

.custom-procedures_option-card_mbVK0 {
    background: var(--ui-white);
    border: 2px solid var(--ui-black-transparent);
    border-radius: 0.5rem;
    padding: calc(0.5rem * 2);
    text-align: center;
    flex-grow: 1;
    cursor: pointer;
    transition: all 0.2s;
    flex-basis: 100px;
}

.custom-procedures_option-card_mbVK0:hover {
    border: 2px solid var(--looks-secondary);
    box-shadow: 0px 0px 0px 4px var(--looks-transparent);
}

.custom-procedures_option-card_mbVK0 + .custom-procedures_option-card_mbVK0 {
    margin-left: 1rem;
}

.custom-procedures_option-icon_JR3Qb {
    max-height: 48px;
    margin-bottom: 0.5rem;
}

.custom-procedures_option-menu_O1f_m {
    text-align: center;
}

.custom-procedures_option-title_LQGE2 {
    font-weight: bold;
}

/* Color options row */

.custom-procedures_color-row_TpOtF {
    display: flex;
    justify-content: center;
    text-align: center;
    border: 2px solid var(--ui-black-transparent);
    border-radius: 0.5rem;
    padding: calc(0.5rem * 1);
    margin-top: 1rem;
    flex-wrap: wrap;
    flex-grow: 1;
    flex-basis: 100px;
    gap: 0.5rem;
    background: var(--ui-white);
}

.custom-procedures_color-option_TQWPk {
    cursor: pointer;
    height: 35px;
    width: 35px;
    border: 2px solid var(--ui-black-transparent);
    border-radius: 50%;
    padding: calc(0.5rem * 1);
    transition: all 0.2s;
}

.custom-procedures_color-option_TQWPk:hover {
    border: 2px solid var(--looks-secondary);
    box-shadow: 0px 0px 0px 4px var(--looks-transparent);
}

.custom-procedures_color-picker_cLTWB {
    appearance: none;
    -moz-appearance: none;
    -webkit-appearance: none;
    display: flex;
    justify-content: center;
    align-items: center;
}

.custom-procedures_color-picker_cLTWB::-moz-color-swatch,
.custom-procedures_color-picker_cLTWB::-webkit-color-swatch {
    border: none;
    height: 0;
    width: 0;
}

.custom-procedures_color-picker_cLTWB::-webkit-color-swatch-wrapper {
    height: 0;
    width: 0;
    padding: 0;
}

.custom-procedures_color-picker_cLTWB::after {
    content: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    position: absolute;
    height: 24px;
    width: 24px;
}

/* "Run without screen refresh" row */

.custom-procedures_checkbox-row_wLWGu {
    margin-top: 1rem;
}

/* Confirmation buttons at the bottom of the modal */

.custom-procedures_button-row_WVIOp {
    margin-top: 1rem;
    font-weight: bolder;
    text-align: right;
}

.custom-procedures_button-row_WVIOp button {
    border: 1px solid var(--ui-black-transparent);
    border-radius: 0.25rem;
    padding: 0.75rem 1rem;
    background: white;
    color: black;
    font-weight: bold;
    font-size: 0.85rem;
}

.custom-procedures_button-row_WVIOp button.custom-procedures_ok-button_gegBg {
    background: var(--looks-secondary);
    border: var(--looks-secondary);
    color: white;
}

[dir="ltr"] .custom-procedures_button-row_WVIOp button + button {
    margin-left: 0.5rem;
}

[dir="rtl"] .custom-procedures_button-row_WVIOp button + button {
    margin-right: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/components/custom-procedures/custom-procedures.css"],"names":[],"mappings":"AAAA,+CAA+C;;AAE/C;sDACsD;;AAEtD,+CAA+C;;AAE/C;IACI,YAAY;IACZ,iBAAiB,EAAE,sDAAsD;AAC7E;;AAEA;IACI,sCAAsC;IACtC,uBAAuB;AAC3B;;AAEA;;IAEI,WAAW;AACf;;AAEA,6DAA6D;;AAE7D;IACI,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,MAAM;IACN,QAAQ;IACR,SAAS;IACT,OAAO;AACX;;AAEA;IACI,mCAAmC;AACvC;;AAEA,0DAA0D;;AAE1D;IACI,aAAa;IACb,8BAA8B;AAClC;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;IAC7C,qBAAqB;IACrB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,eAAe;IACf,oBAAoB;IACpB,iBAAiB;AACrB;;AAEA;IACI,wCAAwC;IACxC,oDAAoD;AACxD;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,sBAAsB;;AAEtB;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;IAClB,6CAA6C;IAC7C,qBAAqB;IACrB,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,iBAAiB;IACjB,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,6CAA6C;IAC7C,kBAAkB;IAClB,yBAAyB;IACzB,oBAAoB;AACxB;;AAEA;IACI,wCAAwC;IACxC,oDAAoD;AACxD;;AAEA;IACI,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;IACxB,aAAa;IACb,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;;IAEI,YAAY;IACZ,SAAS;IACT,QAAQ;AACZ;;AAEA;IACI,SAAS;IACT,QAAQ;IACR,UAAU;AACd;;AAEA;IACI,gDAAiC;IACjC,kBAAkB;IAClB,YAAY;IACZ,WAAW;AACf;;AAEA,qCAAqC;;AAErC;IACI,gBAAgB;AACpB;;AAEA,oDAAoD;;AAEpD;IACI,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,6CAA6C;IAC7C,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;IACjB,YAAY;IACZ,iBAAiB;IACjB,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,8BAA8B;IAC9B,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;AACxB","sourcesContent":["/* overridden by src/lib/themes/guiHelpers.js */\n\n/* make sure to keep these in sync with other constants,\ne.g. STAGE_DIMENSION_DEFAULTS in lib/screen-utils.js */\n\n/* layout contants from `layout-constants.js` */\n\n.modal-content {\n    width: 700px;\n    margin: 50px auto; /* This modal is taller than most, reduce top margin */\n}\n\n.body {\n    background: var(--ui-modal-background);\n    padding: 1.5rem 2.25rem;\n}\n\n.body input[type=\"checkbox\"],\n.body input[type=\"radio\"] {\n    margin: 3px;\n}\n\n/* Blocks workspace for custom procedure declaration editor */\n\n.workspace {\n    min-height: 200px;\n    position: relative;\n}\n\n.workspace :global(.injectionDiv){\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n}\n\n.workspace :global(.blocklySvg) {\n    background-color: var(--ui-primary);\n}\n\n/* Row of \"card\" buttons for modifying custom procedures */\n\n.options-row {\n    display: flex;\n    justify-content: space-between;\n}\n\n.option-card {\n    background: var(--ui-white);\n    border: 2px solid var(--ui-black-transparent);\n    border-radius: 0.5rem;\n    padding: calc(0.5rem * 2);\n    text-align: center;\n    flex-grow: 1;\n    cursor: pointer;\n    transition: all 0.2s;\n    flex-basis: 100px;\n}\n\n.option-card:hover {\n    border: 2px solid var(--looks-secondary);\n    box-shadow: 0px 0px 0px 4px var(--looks-transparent);\n}\n\n.option-card + .option-card {\n    margin-left: 1rem;\n}\n\n.option-icon {\n    max-height: 48px;\n    margin-bottom: 0.5rem;\n}\n\n.option-menu {\n    text-align: center;\n}\n\n.option-title {\n    font-weight: bold;\n}\n\n/* Color options row */\n\n.color-row {\n    display: flex;\n    justify-content: center;\n    text-align: center;\n    border: 2px solid var(--ui-black-transparent);\n    border-radius: 0.5rem;\n    padding: calc(0.5rem * 1);\n    margin-top: 1rem;\n    flex-wrap: wrap;\n    flex-grow: 1;\n    flex-basis: 100px;\n    gap: 0.5rem;\n    background: var(--ui-white);\n}\n\n.color-option {\n    cursor: pointer;\n    height: 35px;\n    width: 35px;\n    border: 2px solid var(--ui-black-transparent);\n    border-radius: 50%;\n    padding: calc(0.5rem * 1);\n    transition: all 0.2s;\n}\n\n.color-option:hover {\n    border: 2px solid var(--looks-secondary);\n    box-shadow: 0px 0px 0px 4px var(--looks-transparent);\n}\n\n.color-picker {\n    appearance: none;\n    -moz-appearance: none;\n    -webkit-appearance: none;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n}\n\n.color-picker::-moz-color-swatch,\n.color-picker::-webkit-color-swatch {\n    border: none;\n    height: 0;\n    width: 0;\n}\n\n.color-picker::-webkit-color-swatch-wrapper {\n    height: 0;\n    width: 0;\n    padding: 0;\n}\n\n.color-picker::after {\n    content: url(./icon--palette.svg);\n    position: absolute;\n    height: 24px;\n    width: 24px;\n}\n\n/* \"Run without screen refresh\" row */\n\n.checkbox-row {\n    margin-top: 1rem;\n}\n\n/* Confirmation buttons at the bottom of the modal */\n\n.button-row {\n    margin-top: 1rem;\n    font-weight: bolder;\n    text-align: right;\n}\n\n.button-row button {\n    border: 1px solid var(--ui-black-transparent);\n    border-radius: 0.25rem;\n    padding: 0.75rem 1rem;\n    background: white;\n    color: black;\n    font-weight: bold;\n    font-size: 0.85rem;\n}\n\n.button-row button.ok-button {\n    background: var(--looks-secondary);\n    border: var(--looks-secondary);\n    color: white;\n}\n\n[dir=\"ltr\"] .button-row button + button {\n    margin-left: 0.5rem;\n}\n\n[dir=\"rtl\"] .button-row button + button {\n    margin-right: 0.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
var _1 = `custom-procedures_modal-content_gpGU2`;
export { _1 as "modal-content" };
export var modalContent = `custom-procedures_modal-content_gpGU2`;
export var body = `custom-procedures_body_Kv_MY`;
export var workspace = `custom-procedures_workspace_GChHs`;
var _2 = `custom-procedures_options-row_aOcgo`;
export { _2 as "options-row" };
export var optionsRow = `custom-procedures_options-row_aOcgo`;
var _3 = `custom-procedures_option-card_mbVK0`;
export { _3 as "option-card" };
export var optionCard = `custom-procedures_option-card_mbVK0`;
var _4 = `custom-procedures_option-icon_JR3Qb`;
export { _4 as "option-icon" };
export var optionIcon = `custom-procedures_option-icon_JR3Qb`;
var _5 = `custom-procedures_option-menu_O1f_m`;
export { _5 as "option-menu" };
export var optionMenu = `custom-procedures_option-menu_O1f_m`;
var _6 = `custom-procedures_option-title_LQGE2`;
export { _6 as "option-title" };
export var optionTitle = `custom-procedures_option-title_LQGE2`;
var _7 = `custom-procedures_color-row_TpOtF`;
export { _7 as "color-row" };
export var colorRow = `custom-procedures_color-row_TpOtF`;
var _8 = `custom-procedures_color-option_TQWPk`;
export { _8 as "color-option" };
export var colorOption = `custom-procedures_color-option_TQWPk`;
var _9 = `custom-procedures_color-picker_cLTWB`;
export { _9 as "color-picker" };
export var colorPicker = `custom-procedures_color-picker_cLTWB`;
var _a = `custom-procedures_checkbox-row_wLWGu`;
export { _a as "checkbox-row" };
export var checkboxRow = `custom-procedures_checkbox-row_wLWGu`;
var _b = `custom-procedures_button-row_WVIOp`;
export { _b as "button-row" };
export var buttonRow = `custom-procedures_button-row_WVIOp`;
var _c = `custom-procedures_ok-button_gegBg`;
export { _c as "ok-button" };
export var okButton = `custom-procedures_ok-button_gegBg`;
export default ___CSS_LOADER_EXPORT___;
